import { Fragment } from "react";
import { List, ListItem, Divider, Typography, Stack } from "@mui/material";

const formatMinutes = (m) => {
  const abs = Math.round(m);
  if (abs >= 60) {
    const h = Math.floor(abs / 60);
    const min = abs % 60;
    return min ? `${h}h ${min}m` : `${h}h`;
  }
  return `${abs}m`;
};

export function TopRoutesSavedList({ items }) {
  if (!items?.length) {
    return <Typography>No routes with time saved</Typography>;
  }

  return (
    <List disablePadding sx={{ width: "95%" }}>
      {items.map((r, i) => (
        <Fragment key={r.id}>
          <ListItem
            sx={{
              alignItems: "flex-start",
              px: 0,
              py: 1,
              paddingBottom: 0.8,
              paddingTop: 0.8,
            }}
          >
            <Stack spacing={0.25} sx={{ width: "100%" }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  letterSpacing: 0.3,
                  lineHeight: 1,
                }}
              >
                {r.name}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  lineHeight: 1,
                }}
              >
                {formatMinutes(r.minutes)} saved
              </Typography>
            </Stack>
          </ListItem>
          {i < items.length - 1 && <Divider component="li" />}
        </Fragment>
      ))}
    </List>
  );
}
